export default {
    "Continue": "继续",
    "With an Unlimited Pass your kids can attend unlimited number of small group classes with": "在优质美国本土老师陪伴下，随时，无限量，体验一站式的任意科目趣味学习",
    "top certified instructors for any subjects offered by Classover": "",
    "Alice and Joes mother": "Alice and Joe’s mother",
    "By continuing, you agree to our ":"点击继续，即表示您同意我们的",
    "User Service Agreement" : '《用户服务协议》',
    "and":'和',
    "Privacy Policy" : '《隐私政策》',
    "Month": "月",
    "sessions": "节课",
    "One Pass that Meets Your Kids Unlimited Learning Needs": "随时约课 • 无限上课",
    "Pay-as-You-Go": "课时套餐",
    "Unlimited Lesson Plan": "会员套餐",
    "3 days ago": "3 days ago",
    "I love Classover lessons": "I love Classover lessons",
    "Students": "学生数",
    "Get Started": "立即开始",
    "Phone Number": "手机号",
    "Go Back": "返回",
    "Personal Infomation": "个人信息",
    "Payment Method": "支付方式",
    "Pay Now": "立刻支付",
    "Checkout": "付款",
    "You will receive a confirmation email shortly": "您将很快收到一封确认电子邮件",
    "Below are the contact information for your course advisor Mandy": "以下是您顾问的联系方式.",
    "Complete Your Profile": "完善资料",
    "Parent Full Name": "家长姓名",
    "Email Address": "邮箱地址",
    "Wechat ID": "微信号",
    "WeChat ID": "微信号",
    "Check your phone for a code": "验证码将会发送至您的手机上",
    "We are sent a 6-character code to": "我们会发送6位数验证码至手机号",
    "The code expires shortly so please enter it soon": "该验证码有效期较短，请及时输入验证。",
    "Success": "成功",
    "Billing history": "支付记录",
    "Name": "姓名",
    "Email": "邮箱",
    // "Name on card": "Name on card",
    // "Card number": "Card number",
    "Login/Register": "登录/注册",
    "Get FREE Trial": "免费试听",
    "Please enter your mobile phone number": "请输入您的手机号",
    "Incorrect mobile number format": "电话号码格式不正确",
    "Due Date": "有效期至",
    "Total": "总计",
    "Description": "描述",
    "Please enter your full name": "请输入您的姓名",
    "Please enter your email": "请输入您的邮箱",
    // "Please enter your wecaht no": "Please enter your wecaht no",
    "Logout": "退出登录",
    "User Center": "用户中心",
    "That code was not valid. Give it another go": "密码无效。再试一次!",
    "FAQ": "常见问题",
    "Please select your country code": "请选择一个国家号",
    "Credit Card": "信用卡",
    "Alipay": "支付宝",
    "By continuing, I accept terms in the": "点击立刻支付, 即表示接受",
    "Service Payment Agreement": "付款授权服务协议",
    "including Refund Policy. I have read the COPPA Direct Notice to Parent. I agree to subscribe to Classover newsletter, SMS messages, and accept the Terms of Use and Privacy Policy.": "退款政策. 我已经阅读儿童网络隐私保护规定家长通知。我同意订阅 Class over的简讯，短信，并接受使用条款和隐私政策。",
    "Total": "总额",
    "Pass": "会员",
    "Payment method": "支付方式",
    "Update": "修改",
    "Contact our advise for assistance.": "请联系我们的顾问以获得帮助",
    "Real Reviews from Real Parents": "来自真实父母的真实评论",
    "Back": "返回",
    "Congratulation!": "恭喜您 ！",
    "You have a Special Offer!": "这是您的专属优惠 ！",
    "You have": "仅剩",
    "Hours": "时",
    "Minutes": "分",
    "Seconds": "秒",
    "Kid(s) Nickname": "孩子昵称",
    "Email Address* (Required)": "电子邮箱",
    "Phone Number": "电话号码",
    "Please enter the correct email address": "请输入正确的电子邮箱格式",
    "Thank You": "感谢支付 ",
    "Your order has been received": "您的订单已收到",
    "Order Details": "订单详情",
    "Order number": "订单号",
    "Date": "日期",
    "Payment method": "支付方式",
    "Customer Details": "客户详情",
    "Contact Information": "联系方式",
    "E-mail": "邮箱",
    "Phone": "电话",
    "advisor": "如有疑问，请联系您的课程顾问",
    "Expires": "到期时间",
    "Subjects": "科目",
    "Teachers": "老师",
    "Schedule": "科目",
    "Pricing": "价格",
    "Download": "下载",
    "English Reading": "英语阅读",
    "Chess": "国际象棋",
    "Singing": "声乐",
    "Public Speaking": "英语演讲",
    "Piano": "钢琴",
    "Guitar": "吉他",
    "Math Olympiad": "奥数",
    "Math and Logic": "数学逻辑",
    "Coding": "编程",
    "Mandarin": "中文",
    "Lego": "乐高",
    "French": "法语",
    "Ukelele": "尤克里里",
    "Classic Literature": "儿童文学经典阅读",
    "Drawing": "美术",
    "Spanish": "西班牙语",
    "Creative Writing": "英语写作",
    "Dance": "舞蹈",
    "Phonics": "自然拼读",
    "MIT APP Development": "MIT 应用软件开发",
    "VIP Package": "VIP 套餐",
    "Credit Package": "课时套餐",
    "Learning Needs": "每月无限上课，随心学",
    "Unlimited 1-6 small group classes ": "任意无限量互动6人小班课",
    "Top certified U.S. teachers": "美国顶级认证教师",
    "100% Live classes": "100% 实时直播互动课 ",
    "Attend any of Afterschool or Tutoring subjects": "无限量小学或者中学课程",
    "Customized class schedule": "随时自主约课，也可以定制课程表",
    "Discounted 1:1 classes": "如需1对1课程，享受超值优惠",
    "Enrich kids": "培养孩子受益终生的学习习惯和成长型思维",
    "Package / Credit Package is not selected": "未选中套餐/课时包",
    "Please contact our course advisor to upgrade your plan": "请联系我们的课程顾问以升级您的套餐",
    "Ok": "好的，我知道了",
    "Please enter the verification code": "请输入验证码",
    "The verification code format is incorrect": "验证码格式不正确",
    "Congratulations!": "恭喜您！",
    "You Received a Special Offer Today": "您获得了我们的特殊福利",
    "Time is limited, please order as soon as possible": "限时提供，请尽快下单哟！",
    "Verification code": "验证码",
    "Send": "发送",
    "This Offer Ends At": "倒计时",
    "Please contact us for current promotions": "请联系我们的课程顾问了解当前的任何促销活动",
    "Sorry": "请联系我们的课程顾问了解当前的任何促销活动",
    "Any questions? Please contact your course advisor": "请联系我们的课程顾问了解当前的任何促销活动",
    "Password": "密码",
    "Verification Code": "验证码登入",
    "Phone number": "手机号",
    "Passwordon": "密码登入",
    "Please enter the password": "请输入密码",
    "Country Code": "国家区号",
    "Please select your country code": "请选择国家区号",

    "Sign in/Sign up": "登入/注册",
    "Welcome to Panda Mandarin": "欢迎来到 Panda Mandarin",
    "loginSlogan": "让孩子轻松学会地道中文",
    "loginSubtitle": "3-18岁分级母语式中文课程，先听说后读写，绘本动画趣味课堂",
    "Simplified Chinese": "简体中文",
    "English": "English",
    "Please tell us a little about yourself": "请告诉我们一些关于您的信息",
    "Phone Number": "电话号码",
    "Kid(s) Nickname": "孩子昵称",
    "Email address": "电子邮箱",
    "Wechat ID": "微信号",
    "Submit": "提交",
    "Thank you for choosing us": "感谢您选择我们",
    "Your Course Adviser will contact you shortly": "您的课程顾问稍后会联系您",
    "Back": "返回",
    "searchArea": "查询国家号",
    "Please select your country code": "请选择国家区号",
    "Please verify and enter the text in the picture": "请进行验证,输入图片内的文字",
    "The Verification Code can not be empty": "验证码不能为空",
    "Please enter the contents": "请输入内容",
    "Successon": "确定",
    "Please verify": "请进行验证",
    "User Does Not Exist": "用户不存在，请重新输入",
    "Price": "金额",
    "Processing Fee (3%)": "手续费 (3%)",
    "USD": "USD",
    "Wrong password": "密码错误, 请重新输入",
    "Enrich kids education and keep them ahead of the curve": "培养孩子受益终生的学习习惯和成长型思维",
    'One Pass that Meets Your Kids Learning Needs': `每月无限上课，随心学`,
    "Unlimited Pass": "VIP套餐",
    "Non-Refundable portion": "该部分为不可退款项",
    "Refundable portion, Transaction fee will be charged for refund": "该部分为可退款项，退款时交易手续费需自付",
    "Top Certified U.S. Teachers": "美国中小学在职名师",
    "100%-Live-Classes": "100%线上互动直播课",
    "Take classes in any subjects": "20+课程任你选择",
    "Customized Schedule": "私人定制课程表",
    "Credits never expire": "课时永不过期",
    "Package details": "套餐详情",
    "PLAN DETAILS": "套餐详情",
    "Number of Students": "学生数",
    "Buy Now": "立即购买",
    "Payment amount": "支付金额",
    "I agree to the": "我同意",
    "Please agree to the service agreement": "请先同意服务协议",
    "Subscribe Now": "立即开通",
    "Lesson Top-up": "课时充值",
    "Membership Subscription": "会员订阅",
    "Start authentic Chinese journey": "开启孩子地道中文成长之路",
    "Recommended": "推荐",
    "Original price": "原价",
    "As low as": "低至",
    "Per month unit": "/月",
    "Vip card title": "{n}个月{title}",
    "Gift lessons": "赠送{n}课时",
    "Total lessons": "总计{n}课时",
    "Lessons unit": "课时",
    "1 child": "一个孩子",
    "2 children": "二个孩子",
    "3 children": "三个孩子",
    "Congratulations!":"恭喜您！",
    "You have claimed a free trial lesson":"成功获得了一节免费试听课机会",
    "Our Course Adviser will contact you shortly":"我们的课程顾问老师稍后会和您联系",
    "Wechatpay":"微信支付",
    "Transaction":"确认购买",
    "Coupon Code":"优惠券代码",
    "Panda Mandarin Project": "熊猫中文项目",
    "Download Center": "下载中心",
    "Student App": "学生端",
    "Parent App": "家长端",
    "Download on App Store": "去Appstore下载",
    "Download on Google Play": "去Google Play下载",
    "Xiaohongshu ID": "小红书号",
    "Contact Phone": "联系电话",
    "US Headquarters": "美国总部",
    "Not logged in": "未登录",
    "Student Name": "学生姓名",
    "Parent Phone": "家长电话",
    "E-mail": "电子邮箱",
    "Interested Course": "感兴趣课程",
    "Submit": "提交",
    "Submit success": "提交成功",
    "Submit failed": "提交失败，请稍后重试",
    "Please enter student name": "请输入学生姓名",
    "Please enter parent phone": "请输入家长电话",
    "Please enter email": "请输入电子邮箱",
    "Please enter interested course": "请输入感兴趣课程",
}



// WEBPACK FOOTER //
// ./src/locales/zh_CN.js